import { render } from "./OvPartInfoModal.vue?vue&type=template&id=75fede64&scoped=true"
import script from "./OvPartInfoModal.vue?vue&type=script&lang=js"
export * from "./OvPartInfoModal.vue?vue&type=script&lang=js"

import "./OvPartInfoModal.vue?vue&type=style&index=0&id=75fede64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fede64"]])

export default __exports__